import * as React from "react";
import { observer, inject } from "mobx-react";
import { Destination } from "typings/microserviceModels/destination-suggestions-flex-module";
import { DestinationSuggestionsProps } from "./typings";
import { WeekendGetaways } from "./WeekendGetaways/WeekendGetaways";
import { Embedding } from "./Embedding/Embedding";
import { EmbeddingRedesign } from "./Embedding/EmbeddingRedesign";
import { reaction } from "mobx";
import { DestinationSelector } from "./DestinationSelector/DestinationSelector";
import { setCookie } from "src/components/utility/cookie";

export enum CookieKeys {
  WEEKEND_GETAWAYS = "weekendGetaways",
}

@inject("compositionStore", "routeStore", "cookies", "destinationSuggestions")
@observer
export class DestinationSuggestions extends React.Component<DestinationSuggestionsProps, {}> {
  public disposer = reaction(
    () => this.props.destinationSuggestions && this.props.destinationSuggestions.destinationSuggestionsOrigin,
    (destinationSuggestionsOrigin) => {
      if (destinationSuggestionsOrigin && this.props.compositionStore) {
        const promise = this.props.compositionStore.updateModule({
          fmId: this.props.flexComponent.fmId,
          locationUserId: destinationSuggestionsOrigin,
        });

        promise.then((result) => {
          if (result.status === 200 && !this.props.flexComponent.model.empty) {
            setCookie({
              key: CookieKeys.WEEKEND_GETAWAYS,
              value: JSON.stringify({
                dstn_sgstn_org_id: destinationSuggestionsOrigin,
              }),
            });
          }
        });
      }
    }
  );

  public componentDidMount() {
    if (this.props.compositionStore && !this.props.flexComponent.model.disableAutoLoad) {
      const savedData = JSON.parse(this.props.cookies!.getCookie(CookieKeys.WEEKEND_GETAWAYS)!);
      let destinationSuggestionOrigin = this.props.destinationSuggestions?.destinationSuggestionsOrigin;
      if (savedData) {
        destinationSuggestionOrigin = savedData.dstn_sgstn_org_id;
      }
      this.props.compositionStore.updateModule({
        fmId: this.props.flexComponent.fmId,
        locationUserId: destinationSuggestionOrigin,
      });
    }
  }

  public componentWillUnmount() {
    this.disposer();
  }

  private hasDestinations(destinations: Destination[]): boolean {
    return destinations && destinations.length > 0;
  }

  public render() {
    const { view } = this.props.flexComponent.model;
    // Supported views by the component
    const localGetAwaysViews = {
      weekendGetaways: <WeekendGetaways props={this.props} />,
      destinationEmbedding: <Embedding props={this.props} />,
      embeddingRedesign: <EmbeddingRedesign props={this.props} />,
      destinationSelector: (
        <DestinationSelector flexComponent={this.props.flexComponent} routeStore={this.props.routeStore} />
      ),
    };

    if (this.props.flexComponent.model.empty || !this.hasDestinations(this.props.flexComponent.model.destinations)) {
      return null;
    }

    return localGetAwaysViews[view] ? localGetAwaysViews[view] : null; // Do not render anything;
  }
}

export default DestinationSuggestions;
